import React, {
  createContext,
  useMemo,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";
import getEnvironment from "utils/getEnvironment";

const { apiUrl, apiToken } = getEnvironment();

const UserContext = createContext();
export default UserContext;

/**
 * Fournit un contexte contenant les informations du client connecté.
 */
export function UserProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const ssoToken = searchParams.get("token") ?? "";
  const embed = window.self !== window.top;

  const [user, setUser] = useState();
  const [token, setToken] = useState();

  // Met à jour l'utilisateur lorsque le token a changé
  const updateUser = useCallback(async () => {
    if (ssoToken) {
      // Suppression du token de l'URL (inutile en iframe : l'URL interne n'est pas visible)
      if (!embed) {
        setSearchParams(
          (prev) => {
            prev.delete("token");
            return prev;
          },
          { replace: true },
        );
      }
      try {
        const res = await fetch(`${apiUrl}/ssologin`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            token: apiToken,
          },
          body: JSON.stringify({ token: ssoToken }),
        });
        const data = await res.json();
        if (data.success === "false") {
          throw new Error(data.error);
        }
        setUser(data.data.user);
        setToken(data.data.accessToken);
      } catch (e) {
        console.warn(e);
        setUser(null);
        setToken(null);
      }
    }
  }, [ssoToken, setSearchParams, embed]);

  useEffect(() => {
    updateUser();
  }, [updateUser]);

  const contextValue = useMemo(
    () => ({ user, token, embed }),
    [user, token, embed],
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
}

UserProvider.propTypes = {
  children: PropTypes.any.isRequired,
};
